import { l10nEnService } from '@uplift/services';

export const sessionPay = 'sessionPay';
export const sessionPayUUID = '00000000-0000-0000-0000-000000000000';

export const networkPreferences = [
  {
    value: 'careFirst',
    label: l10nEnService.onboarding.insurance.careFirst,
    withCustomLabel: true
  },
  {
    value: sessionPay,
    label: l10nEnService.onboarding.insurance.sessionPay,
  },
];
